import * as L from "leaflet";

export const metricIconConfig = {
  size: [5, 5],
  anchor: [15, 30],
};

export const officeIconConfig = {
  size: [35, 35],
  anchor: [17.5, 17.5],
};

export const materialIcon = {
  size: [35, 35],
  fillColor: {
    walk: "#808080", // grey
    Fuss_Weg: "#808080", // grey
    bike: "#b3c42f", // Fahrrad color
    Fahrrad: "#b3c42f", // Fahrrad color
    eBike: "#2d8b3a", // Pedelec color
    Pedelec: "#2d8b3a", // Pedelec color
    train: "#006aaf", // ÖV color
    OeV: "#006aaf", // ÖV color
    bike_and_ride: "#025b29", // Bike&Ride color
    Bike_and_Ride: "#025b29", // Bike&Ride color
    OeV_Fahrrad: "#025b29", // Bike&Ride – DB-Spaltenpräfix, von der Legende genutzt
    car: "#d96a26", // Pkw color
    PKW: "#d96a26", // Pkw color
    car_electric: "#954e8e", // E-Pkw color
    E_Auto: "#954e8e", // E-Pkw color
    park_and_ride: "#993d00", // Park&Ride color
    Park_and_Ride: "#993d00", // Park&Ride color
    Auto_OeV: "#993d00", // Park&Ride – DB-Spaltenpräfix, von der Legende genutzt
    werksbus: "#5b6480", // blue-grey // "linear-gradient(45deg, #FF8C42 50%, #E53E3E 50%)", // Storck orange-red gradient
    Werksbus: "#5b6480", // blue-grey // "linear-gradient(45deg, #FF8C42 50%, #E53E3E 50%)", // Storck orange-red gradient
    bike_and_werksbus: "#5b6480", // blue-grey // "linear-gradient(45deg, #FF8C42 50%, #E53E3E 50%)", // Storck orange-red gradient
    Bike_and_Werksbus: "#5b6480", // blue-grey // "linear-gradient(45deg, #FF8C42 50%, #E53E3E 50%)", // Storck orange-red gradient
    Fahrrad_Werksbus: "#5b6480", // Bike&Werksbus – DB-Spaltenpräfix, von der Legende genutzt
    bahnreaktivierung_and_ride: "#10DADE", // light blue - database transport_id
    "Bahnreaktivierung & Ride": "#10DADE", // light blue - user-friendly display name
    Bahnreakt_Ride: "#10DADE", // light blue - database column prefix variant
    park_ride_and_bike: "#ffd000", // gelb - database transport_id
    "Park & Ride & Bike": "#ffd000", // gelb - user-friendly display name
    Park_Ride_and_Bike: "#ffd000", // gelb - database column prefix variant
  },
  borderColor: {
    walk: "#606060", // darker grey
    Fuss_Weg: "#606060", // darker grey
    bike: "#8F9D25", // darker Fahrrad color
    Fahrrad: "#8F9D25", // darker Fahrrad color
    eBike: "#246E2E", // darker Pedelec color
    Pedelec: "#246E2E", // darker Pedelec color
    train: "#00558C", // darker ÖV color
    OeV: "#00558C", // darker ÖV color
    bike_and_ride: "#014820", // darker Bike&Ride color
    Bike_and_Ride: "#014820", // darker Bike&Ride color
    OeV_Fahrrad: "#014820", // Bike&Ride – DB-Spaltenpräfix, von der Legende genutzt
    car: "#AE551E", // darker Pkw color
    PKW: "#AE551E", // darker Pkw color
    car_electric: "#773E71", // darker E-Pkw color
    E_Auto: "#773E71", // darker E-Pkw color
    park_and_ride: "#7A3100", // darker Park&Ride color
    Park_and_Ride: "#7A3100", // darker Park&Ride color
    Auto_OeV: "#7A3100", // Park&Ride – DB-Spaltenpräfix, von der Legende genutzt
    werksbus: "#5b6480", // blue-grey // "#CC5500", // darker orange-red blend for border
    Werksbus: "#5b6480", // blue-grey // "#CC5500", // darker orange-red blend for border
    bike_and_werksbus: "#5b6480", // blue-grey // "#CC5500", // darker orange-red blend for border
    Bike_and_Werksbus: "#5b6480", // blue-grey // "#CC5500", // darker orange-red blend for border
    Fahrrad_Werksbus: "#5b6480", // Bike&Werksbus – DB-Spaltenpräfix, von der Legende genutzt
    bahnreaktivierung_and_ride: "#7B1FA2", // Darker purple for border
    "Bahnreaktivierung & Ride": "#7B1FA2", // Darker purple for border
    Bahnreakt_Ride: "#7B1FA2", // Darker purple for border
    park_ride_and_bike: "#CCA600", // dunkleres Gelb
    "Park & Ride & Bike": "#CCA600", // dunkleres Gelb
    Park_Ride_and_Bike: "#CCA600", // dunkleres Gelb
  },
  /**
   * Farbe des Symbols im Marker, wo Weiss nicht traegt.
   *
   * Auf dem gelben Park&Ride&Bike-Marker (#ffd000) steht weiss bei einem
   * Kontrast von 1,4:1 - lesbar ist das nicht. Mittleres Grau bringt 2,9:1.
   * Alle uebrigen Verkehrsmittel haben dunkle Fuellfarben und bleiben weiss,
   * deshalb hier nur die Ausnahmen und nicht die ganze Liste.
   */
  symbolColor: {
    park_ride_and_bike: "#757575",
    "Park & Ride & Bike": "#757575",
    Park_Ride_and_Bike: "#757575",
  } as Record<string, string>,
};

/** Standardfarbe der Symbole im Marker. */
export const DEFAULT_SYMBOL_COLOR = "white";

/**
 * Symbolfarbe eines Verkehrsmittels, mit Weiss als Rueckfallebene.
 *
 * Gilt fuer Symbol, Zahl und Legendenkreis gleichermassen - sonst zeigte die
 * Legende einen anderen Marker als die Karte.
 */
export function transportSymbolColor(transportType: string | null): string {
  if (!transportType) return DEFAULT_SYMBOL_COLOR;
  return materialIcon.symbolColor[transportType] ?? DEFAULT_SYMBOL_COLOR;
}
